import { useFormik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoginDataType } from "../type";
import { LoginSchema } from "../Validation";
import { useMutation } from "react-query";
import { LoginApi } from "../Api";
import { toast } from "sonner";
import { useRole } from "../store";

export default function Login() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const checkIsMonitor = useRole((state) => state.checkIsMonitor)

  const { mutate } = useMutation(LoginApi, {
    mutationKey: "user-login",
    onSuccess: (data: any) => {
      checkIsMonitor();
      setIsSubmitting(false);
      const token = data.data.token;
      localStorage.setItem("user_token", token);
      navigate("/");
      toast.success("Login success");
      resetForm();
    },
    onError: (data: any) => {
      setIsSubmitting(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const { touched, errors, values, handleSubmit, resetForm, handleChange } =
    useFormik<LoginDataType>({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema: LoginSchema,
      onSubmit: (data) => {
        setIsSubmitting(true);
        mutate(data);
      },
    });

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo text-decoration-none">
          <Link to="#" className="text-decoration-none fs-1 fw-bold">
            User Panel
          </Link>
        </div>
        <div className="card">
          <div className="card-body login-card-body rounded-3">
            <p className="login-box-msg">Login to start your session</p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    className={`form-control ${touched.email && errors.email ? "is-invalid" : ""
                      }`}
                    placeholder="Email"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope" />
                    </div>
                  </div>
                </div>
                {touched.email && errors.email ? (
                  <div className="text-danger">{errors.email}</div>
                ) : null}
              </div>

              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    name="password"
                    className={`form-control ${touched.password && errors.password ? "is-invalid" : ""
                      }`}
                    placeholder="Password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div>
                </div>
                {touched.password && errors.password ? (
                  <div className="text-danger">{errors.password}</div>
                ) : null}
              </div>

              <div>
                <button
                  className="btn btn-primary w-100"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
